export function openInboxForLead(leadUid: string) {
  window.open(`#/inbox?leadUid=${leadUid}`, '_blank');
}
